<template>
      <v-layout column>
        <div class="text-xs-left title ma-2">
          Shopping Cart
        </div>

        <v-layout wrap>
          <v-flex sm12 md8 lg8>
              <span v-if="haveItems">
                <v-layout>
                    <v-flex xs6></v-flex>
                    <v-flex xs2>Price</v-flex>
                    <v-flex sm2 xs4>Quantity</v-flex>
                </v-layout>
                <hr />

                <CartItem v-for="item in cartItems"  :key="item.title" :cartItem="item"
                 ></CartItem>
              </span>
              <div v-else class="subheading">
                There is nothing in your shopping cart.
              </div>

          </v-flex>
          <v-flex sm12 md4 lg4>
                <CartSubtotal v-on:gotoCheckout="gotoCheckout"></CartSubtotal>
          </v-flex>
        </v-layout>

      </v-layout>

</template>

<script>
import {mapState, mapGetters} from 'vuex'
import CartItem from './CartItem.vue'
import CartSubtotal from './CartSubtotal.vue'

export default {
  name: 'ViewCart',
  components: {
    CartItem,
    CartSubtotal
  },
  data: function () {
    return {
      headers: [
        {text: '', value: '', sortable: false},
        {
          text: 'Item',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {text: 'Price', value: 'price', sortable: false},
        {text: 'Quantity', align: 'right', value: 'quantity', sortable: false}
      ]
    }
  },
  methods: {
    gotoCheckout: function () {
      const aid = this.$route.params.aid
      this.$router.push(`/${aid}/checkout`)
    }
  },
  computed: {
    ...mapState({
    }),
    ...mapGetters({
      cartItems: 'cart/items'
    }),
    haveItems: function () {
      return this.cartItems && this.cartItems.length > 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.viewcart {
    width: 100%;
}
</style>
